import React from 'react';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, marginBottom, linkText } from '../../../helpers/getEmailStyles';

class ListPublishRequest extends React.Component {

	render() {
		const { content: { hostName, listId, listTitle, logo, siteName } } = this.props;
		let URL = url + `/become-a-host/${listId}/home`;

		return (
			<Layout>
				<Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
				<div style={body}>
					<div style={fontWeightBold}>
						Bonjour Admin,
					</div>
					<EmptySpace height={20} />
					<div>
						Une nouvelle annonce a été soumise par {hostName} pour examen. Veuillez vérifier les détails et prendre les mesures nécessaires.
					</div>
					<EmptySpace height={20} />
					<div>
						<a style={linkText} href={URL}>Cliquez ici</a> pour accéder à la section des demandes d'annonces.
					</div>
					<EmptySpace height={20} />
					<div style={marginBottom}><span style={fontWeightBold}>Détails de l'annonce :</span></div>
					<div style={marginBottom}><span style={fontWeightBold}>ID :</span> {listId}</div>
					<div><span style={fontWeightBold}>Titre :</span> {listTitle}</div>
					<EmptySpace height={20} />
					<EmailSignature siteName={siteName} />
				</div>
				<EmptySpace height={40} />
				<Footer siteName={siteName} />
				<EmptySpace height={20} />
			</Layout>
		);
	}

}

export default ListPublishRequest;